window.Plus = window.Plus || {};

Plus.SecondaryAddToCart = {
  init: init,
  makeSticky: makeSticky 
}

document.addEventListener('DOMContentLoaded', function() { 
  Plus.SecondaryAddToCart.init();
  Plus.SecondaryAddToCart.makeSticky();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    Plus.SecondaryAddToCart.init();
    Plus.SecondaryAddToCart.makeSticky();
  });
}

function init() {
  const primaryAtcButton = document.querySelector('.product--add-to-cart-button');
  const secondaryAtcButton = document.querySelector('.secondary-atc-button');
  const secondaryAtcContainer = document.querySelector('.secondary-atc');

  if (!secondaryAtcButton || !primaryAtcButton) {
    return;
  }

  secondaryAtcButton.addEventListener('click', function() {
    this.classList.add('working');
    primaryAtcButton.click();
    setTimeout(() => {
      this.classList.remove('working');
    }, 1000);
  })

  const quantitySelector = {
    primary: (() => {
      let container = document.querySelector('.primary-quantity-selector');
      return {
        container: container,
        input: container.querySelector('.qty-selector--primary'),
        minus: container.querySelector('.qty-minus'),
        plus: container.querySelector('.qty-plus')
      };
    })(),
    secondary: (() => {
      let container = document.querySelector('.secondary-quantity-selector');
      return {
        container: container,
        input: container.querySelector('.qty-selector--secondary'),
        minus: container.querySelector('.qty-minus'),
        plus: container.querySelector('.qty-plus')
      };
    })()
  };

  function quantityUpdater(selector1, selector2, operation) {
    return function() {
      let value1 = parseInt(selector1.input.value);
      let value2 = parseInt(selector2.input.value);
      if (operation === 'add') {
        selector1.input.value = value1 + 1;
      } else if (operation === 'subtract' && value1 > 0) {
        selector1.input.value = value1 - 1;                    
      }
      selector1.input.value <= 1 ? selector1.minus.classList.add('disabled') : selector1.minus.classList.remove('disabled');
      selector2.input.value <= 1 ? selector2.minus.classList.add('disabled') : selector2.minus.classList.remove('disabled');
    }
  }

  quantitySelector.secondary.minus.addEventListener('click', quantityUpdater(quantitySelector.primary, quantitySelector.secondary, 'subtract'));
  quantitySelector.secondary.plus.addEventListener('click', quantityUpdater(quantitySelector.primary, quantitySelector.secondary, 'add'));
  quantitySelector.primary.minus.addEventListener('click', quantityUpdater(quantitySelector.secondary, quantitySelector.primary, 'subtract'));
  quantitySelector.primary.plus.addEventListener('click', quantityUpdater(quantitySelector.secondary, quantitySelector.primary, 'add'));

  quantitySelector.primary.input.addEventListener('input', function() {
    quantitySelector.secondary.input.value = quantitySelector.primary.input.value;
  })

  quantitySelector.secondary.input.addEventListener('input', function() {
    quantitySelector.primary.input.value = quantitySelector.secondary.input.value;
  })
}

function makeSticky() {
  const secondaryAtcContainer = document.querySelector('.secondary-atc');
  const secondaryAtcInner = document.querySelector('.secondary-atc-section');
  const primaryAtcButton = document.querySelector('.product--add-to-cart-button');

  if (!secondaryAtcContainer) {
    return;
  }

  if (secondaryAtcInner && secondaryAtcInner.classList.contains('secondary-atc-section-position--static') || !secondaryAtcInner) {
    return;
  } else {
    secondaryAtcContainer.classList.add('fixed');
  }

  window.addEventListener('scroll', function() {
    let referencePosition = primaryAtcButton.getBoundingClientRect().bottom;
    if (referencePosition < 0) {
      secondaryAtcContainer.classList.remove('fixed--is-closed');
      secondaryAtcContainer.classList.add('fixed--is-open');
    } else {
      secondaryAtcContainer.classList.remove('fixed--is-open');
      secondaryAtcContainer.classList.add('fixed--is-closed');
    }
  });
}